import Firebase from 'firebase/app';

let App: Firebase.app.App;
export default (options: unknown, name: string): Firebase.app.App => {
	if (App) return App;
	App = Firebase.initializeApp(Object.assign({}, options), name);
	return App;
};
